'use client';

import { c as _c } from "react/compiler-runtime";
import { motion } from 'framer-motion';
import { RefObject, useCallback, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useEventListener, useMediaQuery, useOnClickOutside } from 'usehooks-ts';
import IconClose from '@/components/assets/icon_close.svg';
import { HTC_ACCESS_TOKEN_KEY } from '@/constants/auth';
import { useAuthContext } from '@/context/AuthContext';
import { useConfigsContext } from '@/context/ConfigsContext';
import { useVSCSdkContext } from '@/context/VSCSdkContext';
import { getClientCookie } from '@/lib/client-cookie';
import { cn } from '@/lib/utils';
type ViverseCommunityDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};
function ViverseCommunityDialog(t0) {
  const $ = _c(41);
  const {
    open,
    onOpenChange
  } = t0;
  const dialogRef = useRef(null);
  const iframeRef = useRef(null);
  const [iframeContentWindow, setIframeContentWindow] = useState(null);
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const {
    isMountedHeader
  } = useVSCSdkContext();
  const {
    appConfig
  } = useConfigsContext();
  const {
    isSignedIn
  } = useAuthContext();
  const communityWebUrl = appConfig?.features?.community_web_url;
  const isCommunityReady = isSignedIn && !!iframeContentWindow;
  const isDialogReady = open && !!iframeContentWindow && isMountedHeader;
  let t1;
  if ($[0] !== communityWebUrl || $[1] !== iframeContentWindow) {
    t1 = async () => {
      const postData = {
        method: "initialize-auth",
        payload: {
          data: getClientCookie(HTC_ACCESS_TOKEN_KEY) ?? ""
        }
      };
      iframeContentWindow.postMessage(postData, communityWebUrl);
    };
    $[0] = communityWebUrl;
    $[1] = iframeContentWindow;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const postCommunityInitAuth = t1;
  let t2;
  if ($[3] !== communityWebUrl || $[4] !== iframeContentWindow || $[5] !== isDesktop) {
    t2 = () => {
      const postData_0 = {
        method: "community-web-fullscreen",
        payload: {
          state: !isDesktop
        }
      };
      iframeContentWindow.postMessage(postData_0, communityWebUrl);
    };
    $[3] = communityWebUrl;
    $[4] = iframeContentWindow;
    $[5] = isDesktop;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const postCommunityFullScreen = t2;
  let t3;
  let t4;
  if ($[7] !== isDialogReady || $[8] !== postCommunityFullScreen) {
    t3 = () => {
      if (isDialogReady) {
        postCommunityFullScreen();
      }
    };
    t4 = [isDialogReady, postCommunityFullScreen];
    $[7] = isDialogReady;
    $[8] = postCommunityFullScreen;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[11] !== isCommunityReady || $[12] !== postCommunityInitAuth) {
    t5 = () => {
      if (isCommunityReady) {
        postCommunityInitAuth();
      }
    };
    t6 = [isCommunityReady, postCommunityInitAuth];
    $[11] = isCommunityReady;
    $[12] = postCommunityInitAuth;
    $[13] = t5;
    $[14] = t6;
  } else {
    t5 = $[13];
    t6 = $[14];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[15] !== isCommunityReady || $[16] !== postCommunityFullScreen) {
    t7 = () => {
      if (isCommunityReady) {
        postCommunityFullScreen();
      }
    };
    t8 = [isCommunityReady, postCommunityFullScreen];
    $[15] = isCommunityReady;
    $[16] = postCommunityFullScreen;
    $[17] = t7;
    $[18] = t8;
  } else {
    t7 = $[17];
    t8 = $[18];
  }
  useEffect(t7, t8);
  let t9;
  if ($[19] !== onOpenChange) {
    t9 = () => {
      onOpenChange(false);
    };
    $[19] = onOpenChange;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  useOnClickOutside(dialogRef as RefObject<HTMLDivElement>, t9);
  let t10;
  if ($[21] !== onOpenChange) {
    t10 = event => {
      if (event.data?.source?.startsWith("react")) {
        return;
      }
      bb50: switch (event.data.method) {
        case "friend-list-modified":
        case "new-note":
        case "friend-request-list-modified":
          {
            break bb50;
          }
        case "close-community-web":
          {
            onOpenChange(false);
          }
      }
    };
    $[21] = onOpenChange;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  useEventListener("message", t10);
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      opacity: 0
    };
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const t12 = open ? 1 : 0;
  let t13;
  if ($[24] !== t12) {
    t13 = {
      opacity: t12
    };
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      ease: "easeOut"
    };
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const t15 = !open;
  let t16;
  if ($[27] !== t15) {
    t16 = cn("border-vive-primary-70 bg-vive-popup fixed top-1/2 left-1/2 z-10000 flex size-full -translate-x-1/2 -translate-y-1/2 flex-col overflow-hidden rounded-2xl border-2 p-1 px-8! outline-hidden lg:right-4 lg:left-auto lg:max-h-[calc(100dvh-176px)] lg:w-[410px] lg:translate-x-0", {
      hidden: t15
    });
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="absolute top-0"><div className="lg:header-4 relative flex h-[80px] w-full items-center justify-center py-[18px] text-center lg:text-2xl"><IconClose className="absolute right-0 lg:hidden" /></div></div>;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== communityWebUrl || $[31] !== isMountedHeader || $[32] !== isSignedIn || $[33] !== open) {
    t18 = isSignedIn && isMountedHeader && <iframe allow="camera *; microphone *" className={cn("absolute top-0 left-0 size-full flex-1", {
      hidden: !open
    })} ref={iframeRef} src={communityWebUrl} frameBorder="0" allowFullScreen={true} onLoad={() => {
      const iframeWindow = iframeRef.current?.contentWindow;
      setIframeContentWindow(iframeWindow);
    }} />;
    $[30] = communityWebUrl;
    $[31] = isMountedHeader;
    $[32] = isSignedIn;
    $[33] = open;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t16 || $[36] !== t18) {
    t19 = <div className={t16}>{t17}{t18}</div>;
    $[35] = t16;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t13 || $[39] !== t19) {
    t20 = createPortal(<motion.div ref={dialogRef} initial={t11} animate={t13} transition={t14}>{t19}</motion.div>, document.body);
    $[38] = t13;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  return t20;
}
export default ViverseCommunityDialog;